export default "__VITE_ASSET__TML69jq4__"